import { render, staticRenderFns } from "./CardMaterial.vue?vue&type=template&id=0d5f9ffc&"
import script from "./CardMaterial.vue?vue&type=script&lang=ts&"
export * from "./CardMaterial.vue?vue&type=script&lang=ts&"
import style0 from "./CardMaterial.vue?vue&type=style&index=0&id=0d5f9ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports